import React, { useMemo } from "react";

import AddRelationsModal from "components/UI/_TODO/Expenditure/components/AddRelationsModal/AddRelationsModal";

import { useBuildingMatchingContext } from "./BuildingMatchingContext";
import ProductInfoModal from "entities/ProductInfoModal/ProductInfoModal";

interface IProps {
  loadSectionExpenditures: () => void;
}

const BuildingMatchingModals = ({ loadSectionExpenditures }: IProps) => {
  const {
    isInfo,
    isLoaidng,
    isMatching,
    setIsInfo,
    setIsMatching,
    setRelationOriginInfo,
    data,
    objectId,
    relationOriginInfo,
  } = useBuildingMatchingContext();

  const matchingTarget = useMemo(() => {
    if (!isMatching || !relationOriginInfo) return null;
    return {
      id: relationOriginInfo.id,
    };
  }, [isMatching, relationOriginInfo]);

  return (
    <>
      <ProductInfoModal
        isOpen={isInfo}
        onClose={() => {
          setIsInfo(false);
          setRelationOriginInfo(null);
        }}
        onOpenEditing={() => {
          setIsInfo(false);
          setIsMatching(true);
        }}
        canEdit={!!relationOriginInfo?.is_default}
        isLoading={isLoaidng}
        section={data?.section?.name}
        number={data?.number}
        justification={data?.justification}
        expenditureName={data?.name}
        price={data?.price}
        count={data?.count}
      />
      <AddRelationsModal
        relationOriginInfo={matchingTarget}
        handleClose={() => {
          setIsMatching(false);
          setRelationOriginInfo(null);
        }}
        objectId={String(objectId)}
        updateExpenditure={() => {
          loadSectionExpenditures?.();
          setIsMatching(false);
        }}
        type={undefined}
      />
    </>
  );
};

export default BuildingMatchingModals;
